import { Autocomplete, Chip, TextField } from '@mui/material';

export interface CodeNameOption {
  code: string;
  name: string;
}

export interface CodeNameMultiSelectProps<T extends CodeNameOption> {
  label: string;
  options: T[];
  value: string[];
  onChange: (codes: string[]) => void;
  loading?: boolean;
  disabled?: boolean;
  helperText?: string;
}

/**
 * Generic multi-select over `{code, name}` reference data (sales channels, customer groups) —
 * selects by name, stores codes. Used by the promotion builder's restrictions section.
 */
export function CodeNameMultiSelect<T extends CodeNameOption>({
  label,
  options,
  value,
  onChange,
  loading = false,
  disabled = false,
  helperText,
}: CodeNameMultiSelectProps<T>) {
  const selected = options.filter((o) => value.includes(o.code));

  return (
    <Autocomplete
      multiple
      disabled={disabled}
      loading={loading}
      options={options}
      value={selected}
      getOptionLabel={(o) => o.name}
      isOptionEqualToValue={(a, b) => a.code === b.code}
      onChange={(_event, next) => onChange(next.map((o) => o.code))}
      renderTags={(tags, getTagProps) =>
        tags.map((tag, index) => {
          const { key, ...tagProps } = getTagProps({ index });
          return <Chip size="small" label={tag.name} key={key} {...tagProps} />;
        })
      }
      renderInput={(params) => <TextField {...params} label={label} helperText={helperText} />}
    />
  );
}
